import { ForgotPasswordForm } from './Form';
import { Footer } from './Footer';
import ForgotPasswordBG from '@assets/images/landing_page_ausmeat.png';

export const ForgotPassword = () => {
  return (
    <div className="lg:flex lg:fixed h-24 lg:h-screen w-full">
      <div className="hidden lg:block lg:relative h-full lg:w-6/12">
        <div className="absolute inset-0 scrim"></div>
        <Footer className="absolute bottom-0 inset-x-0" />
        <div
          className="w-full h-full bg-no-repeat bg-cover items-end flex justify-center"
          style={{ backgroundImage: `url(${ForgotPasswordBG})` }}
        />
      </div>
      <div className="lg:w-6/12 h-full bg-white">
        <div className="h-full flex justify-center items-center p-4 lg:p-0">
          <ForgotPasswordForm />
        </div>
      </div>
    </div>
  );
};
